export const dockTranslations = {
  en: {
    pageTitle: 'Dock',
    loading: 'Loading Dock...',
    calculating: 'Calculating distance...',
    noDocksMemory: 'No dock information in memory - downloading from server',
    docksError: 'Problem receiving dock data: ',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving the dock data! Please restart the app and try again.',
    okButton: 'Ok',
    currentDistance: 'Current distance: ',
    landlinePhone: 'Landline Phone: ',
    mobilePhone: 'Mobile Phone: ',
    boatSpaces: 'Boat spaces: ',
    dockType: 'Dock type: ',
    publicServices: 'Public services: ',
    memberServices: 'Member services: ',
    description: 'Description: ',
    restaurants: 'Restaurants: ',
    hotels: 'Hotels: '
  },
  it: {
    pageTitle: 'Attracco',
    loading: 'Caricamento Attracco...',
    calculating: 'Calcolo distanza...',
    noDocksMemory: 'Non sono presenti informazioni sugli attracchi in memoria - scaricamento dal server',
    docksError: 'Problema nella ricezione dei dati sugli attracchi: ',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati sugli attracchi! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok',
    currentDistance: 'Distanza attuale: ',
    landlinePhone: 'Telefono Fisso: ',
    mobilePhone: 'Telefono Cellulare: ',
    boatSpaces: 'Posti barca: ',
    dockType: 'Tipo di attracco: ',
    publicServices: 'Servizi pubblici: ',
    memberServices: 'Servizi ai soci: ',
    description: 'Descrizione: ',
    restaurants: 'Ristoranti: ',
    hotels: 'Alberghi: '
  }
}; 